import Cookies from 'js-cookie';
import { UAParser } from 'ua-parser-js';

import { visitorService } from '@/shared/services/visitor';

import KinesisService, { type KinesisEventProps } from './kinesis.service';

const kinesisService = new KinesisService(
  Cookies,
  visitorService,
  UAParser(window.navigator.userAgent),
  import.meta.env.VITE_KINESIS_LAMBDA_FUNCTION_URL,
);

export { kinesisService, type KinesisService, type KinesisEventProps };
